<template>
  <ul class="submenu">
    <li v-for="item in items" :key="item.name">
      <item
        :id="submenuId(item)"
        :item="item"
        :current-url="currentUrl"
        @itemSelected="item => $emit('itemSelected', item)"
      />
    </li>
  </ul>
</template>

<script>
import Item from './Item';

export default {
  components: {
    Item
  },
  props: {
    id: {
      type: String,
      default: 'submenu'
    },
    items: {
      type: Array,
      default: () => []
    },
    currentUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    submenuId(item) {
      return this.id + '-' + item.name;
    }
  }
};
</script>
